import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import { DefaultRootState, Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import configureStore from "app/configure.store";
import React from "react";
import ReactDOM from "react-dom";

import "./index.scss";
import App from "./app/App";

const history = createBrowserHistory();
const initialState: DefaultRootState | undefined = undefined;
const store = configureStore(initialState, history);

if (typeof (document) !== "undefined" && typeof (window) !== "undefined") {
    setTimeout(() => {
        document.documentElement.style.setProperty("--scrollbar-width", (window.innerWidth - document.body.clientWidth) + "px");
    }, 250);
}

ReactDOM.render(
    <HelmetProvider>
        <BrowserRouter>
            <Provider store={store}>
                <App />
            </Provider>
        </BrowserRouter>
    </HelmetProvider>,
    document.getElementById("root")
);
